import domain from "@/environment";
import Dossier from "../../models/dossier";
import axios from "axios";
import FileType from "../../models/ocrfileTypes";
import File from "../../models/ocrFile";

const state = {
  dossier: null,
  dossiers: [],
  dossiersByOperation: [],
  delegataires: [],
  fileTypes: [],
  files: [],
  dossierLoading: false,
  dossierRows: 0,
};
const getters = {
  getdossier: (state) => state.dossier,
  getAlldossiers: (state) => state.dossiers,
  getDossiersByOperation: (state) => state.dossiersByOperation,
  getOcrDelegataires: (state) => state.delegataires,
  getOcrFileType: (state) => state.fileTypes,
  getOcrFiles: (state) => state.files,
  getLoadingdossier: (state) => state.dossierLoading,
  getTotalRowDossier: (state) => state.dossierRows,
};
const mutations = {
  DO_NOTHING() {},
  SET_DOSSIER(state, payload) {
    if (payload) {
      state.dossier = Dossier.create(payload);
    } else {
      state.dossier = null;
    }
  },
  SET_OCRDELEGATAIRE(state, payload) {
    if (payload) {
      state.delegataires = payload;
    } else {
      state.delegataires = [];
    }
  },
  SET_OCR_FILE_TYPE(state, payload) {
    if (payload) {
      state.fileTypes = payload.map((item) => FileType.create(item));
    } else {
      state.fileTypes = [];
    }
  },
  SET_OCR_FILES(state, payload) {
    if (payload) {
      state.files = payload.map((item) => File.create(item));
    } else {
      state.files = [];
    }
  },
  PUSH_DOSSIER(state, payload) {
    state.dossiers.push(Dossier.create(payload));
  },
  UPDATE_DOSSIER(state, payload) {
    for (let index = 0; index < state.dossiers.length; index++) {
      if (state.dossiers[index].id == payload.id) {
        if (payload.lock !== undefined) {
          state.dossiers[index].lock = payload.lock;
        } else {
          state.dossiers[index].update(payload);
        }
        break;
      }
    }
  },

  DELETE_DOSSIER(state, payload) {
    for (let index = 0; index < state.dossiers.length; index++) {
      if (state.dossiers[index].id == payload.id) {
        state.dossiers.splice(index, 1);
        break;
      }
    }
  },
  SET_DOSSIERS(state, payload) {
    if (payload) {
      state.dossiers = payload.map((item) => Dossier.create(item));
    } else {
      state.dossiers = [];
    }
  },
  SET_DOSSIERS_BY_OPERATION(state, payload) {
    if (payload) {
      state.dossiersByOperation = payload.map((item) => Dossier.create(item));
    } else {
      state.dossiersByOperation = [];
    }
  },
  UPDATE_DOSSIER_ROW(state, payload) {
    if (payload) {
      state.dossierRows = payload;
    } else {
      state.dossierRows = 0;
    }
  },

  SET_DOSSIERLOADING(state, payload) {
    if (payload) {
      state.dossierLoading = payload;
    } else {
      state.dossierLoading = false;
    }
  },
};

const actions = {
  async OcrDelegataires({ commit }, payload) {
    var params = {
      search: payload.search,
    };
    try {
      const response = await axios.get(domain + "/ocrdelegataires", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });
      commit("SET_OCRDELEGATAIRE", response.data.data);
    } catch (error) {
      throw error.response.data.message;
    }
  },
  async OcrFileTypes({ commit }, payload) {
    var params = {
      search: payload.search,
    };
    try {
      const response = await axios.get(domain + "/ocrfiletypes", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });
      commit("SET_OCR_FILE_TYPE", response.data.data);
    } catch (error) {
      throw error.response.data.message;
    }
  },
  async alldossier({ commit }, payload) {
    commit("SET_DOSSIERS");
    commit("SET_DOSSIERLOADING", true);
    const params = {
      page: payload.page,
      per_page: payload.per_page,
      search: payload.search,
      client: payload.client,
      client_id: payload.client_id,
      entreprise_id: payload.entreprise_id,
      operation: payload.operation,
      status: payload.status,
      date_from: payload.date_from,
      date_to: payload.date_to,
    };
    try {
      const response = await axios.get(domain + "/ocrdossiers", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });
      const data = response.data.data ?? response.data;
      const list = Array.isArray(data) ? data : (data?.data ?? []);
      commit("UPDATE_DOSSIER_ROW", list.length);
      commit("SET_DOSSIERS", list);
      return response.data;
    } catch (error) {
      throw error.response.data.message;
    } finally {
      commit("SET_DOSSIERLOADING", false);
    }
  },
  async dossiersByOperation({ commit }, payload = {}) {
    const params = {
      page: payload.page ?? 1,
      per_page: payload.per_page ?? 500,
    };
    if (payload.operation != null) params.operation = payload.operation;
    if (payload.entreprise_id != null) params.entreprise_id = payload.entreprise_id;
    if ("noasigned" in payload) params.noasigned = payload.noasigned ? 1 : 0;
    try {
      const response = await axios.get(domain + "/ocrdossiers", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });
      const data = response.data?.data ?? response.data;
      const list = Array.isArray(data) ? data : (data?.data ?? []);
      commit("SET_DOSSIERS_BY_OPERATION", list);
      return list;
    } catch (error) {
      commit("SET_DOSSIERS_BY_OPERATION", []);
      throw error.response?.data?.message ?? error.message;
    }
  },
  async store_dossier({ commit, state }, payload) {
    commit("SET_DOSSIERLOADING", true);
    try {
      const response = await axios.post(domain + `/ocrdossiers`, payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });

      commit("PUSH_DOSSIER", response.data.data);
      commit("UPDATE_DOSSIER_ROW", (state.dossierRows || 0) + 1);
      return true;
    } catch (error) {
      throw error.response.data.message;
    } finally {
      commit("SET_DOSSIERLOADING", false);
    }
  },
  async edit_dossier({ commit }, payload) {
    commit("SET_DOSSIERLOADING", true);
    try {
      const response = await axios.put(
        domain + `/ocrdossiers/` + payload.id,
        payload,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );

      commit("UPDATE_DOSSIER", response.data.data);
      commit("SET_DOSSIERLOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_DOSSIERLOADING", false);
      throw error.response.data.message;
    }
  },
  async delete_dossier({ commit, state }, payload) {
    commit("SET_DOSSIERLOADING", true);
    try {
      await axios.delete(domain + `/ocrdossiers/` + payload.id, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("DELETE_DOSSIER", payload);
      commit("UPDATE_DOSSIER_ROW", Math.max(0, (state.dossierRows || 0) - 1));
      return true;
    } catch (error) {
      throw error.response.data.message;
    } finally {
      commit("SET_DOSSIERLOADING", false);
    }
  },

  async getDossierResume(_context, dossierId) {
    try {
      const response = await axios.get(domain + `/ocrdossiers/resume/` + dossierId, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      return response.data?.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async one_dossier({ commit }, payload) {
    commit("DO_NOTHING");
    try {
      const response = await axios.get(domain + `/ocrdossiers/` + payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });

      return Dossier.create(response.data.data);
    } catch (error) {
      throw error.response.data.message;
    }
  },

  async allfiles({ commit }, payload) {
    commit("SET_OCR_FILES");
    var params = {
      ocr_dossier_id: payload,
    };
    try {
      const response = await axios.get(domain + "/ocrfiles", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });
      commit("SET_OCR_FILES", response.data.data);
      return true;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  async upload_file({ commit }, payload) {
    commit("DO_NOTHING");
    try {
      const response = await axios.post(domain + `/ocrfiles`, payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });

      return File.create(response.data.data);
    } catch (error) {
      throw error.response.data.message;
    }
  },
  async delete_file({ commit }, payload) {
    commit("SET_DOSSIERLOADING", true);
    try {
      await axios.delete(domain + `/ocrfiles/` + payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });

      commit("SET_DOSSIERLOADING", false);
      return true;
    } catch (error) {
      commit("SET_DOSSIERLOADING", false);
      throw error.response.data.message;
    }
  },

  async send_dossier({ commit }, payload) {
    commit("SET_DOSSIERLOADING", true);
    try {
      await axios.post(domain + `/ocrdossiers-send/` + payload, null, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });

      commit("SET_DOSSIERLOADING", false);
      return true;
    } catch (error) {
      commit("SET_DOSSIERLOADING", false);
      throw error.response.data.message;
    }
  },

  async download_file({ commit }, payload) {
    commit("DO_NOTHING");
    try {
      const response = await axios.get(
        domain + `/ocrfiles-download/` + payload,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
          responseType: "blob",
        }
      );

      return response.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },

  // Commentaires
  async index_commentaires(_context, ocrdossierId) {
    try {
      const response = await axios.get(
        domain + `/ocrdossiers/${ocrdossierId}/commentaires`,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      const data = response.data.data ?? response.data;
      return Array.isArray(data) ? data : data?.data ?? [];
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async store_commentaire(_context, { ocrdossierId, body }) {
    try {
      const response = await axios.post(
        domain + `/ocrdossiers/${ocrdossierId}/commentaires`,
        body,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async show_commentaire(_context, { ocrdossierId, commentaireId }) {
    try {
      const response = await axios.get(
        domain + `/ocrdossiers/${ocrdossierId}/commentaires/${commentaireId}`,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async update_commentaire(_context, { ocrdossierId, commentaireId, body }) {
    try {
      const response = await axios.put(
        domain + `/ocrdossiers/${ocrdossierId}/commentaires/${commentaireId}`,
        body,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async destroy_commentaire(_context, { ocrdossierId, commentaireId }) {
    try {
      await axios.delete(
        domain + `/ocrdossiers/${ocrdossierId}/commentaires/${commentaireId}`,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      return true;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  // Photos
  async index_photos(_context, { ocrdossierId, params = {} }) {
    try {
      const response = await axios.get(
        domain + `/ocrdossiers/${ocrdossierId}/photos`,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
          params: params, // Passer les filtres comme query parameters
        }
      );
      const data = response.data.data ?? response.data;
      return Array.isArray(data) ? data : data?.data ?? [];
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async store_photo(_context, { ocrdossierId, formData }) {
    try {
      const response = await axios.post(
        domain + `/ocrdossiers/${ocrdossierId}/photos`,
        formData,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async show_photo(_context, { ocrdossierId, photoId }) {
    try {
      const response = await axios.get(
        domain + `/ocrdossiers/${ocrdossierId}/photos/${photoId}`,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async update_photo(_context, { ocrdossierId, photoId, body }) {
    try {
      const response = await axios.put(
        domain + `/ocrdossiers/${ocrdossierId}/photos/${photoId}`,
        body,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async destroy_photo(_context, { ocrdossierId, photoId }) {
    try {
      await axios.delete(
        domain + `/ocrdossiers/${ocrdossierId}/photos/${photoId}`,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      return true;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async import_photos(_context, { ocrdossierId, formData }) {
    try {
      const response = await axios.post(
        domain + `/ocrdossiers/${ocrdossierId}/photos/import`,
        formData,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async export_photos(_context, { ocrdossierId, photoIds }) {
    try {
      const params = {};
      if (photoIds && photoIds.length > 0) {
        params.photo_ids = photoIds.join(",");
      }
      const response = await axios.get(
        domain + `/ocrdossiers/${ocrdossierId}/photos/export`,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
          params,
          responseType: "blob",
        }
      );
      return { blob: response.data, headers: response.headers };
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * Import de documents dans un dossier depuis un fichier ZIP (format export documents).
   * POST /api/ocrdossiers/{ocrdossierId}/documents/import avec multipart/form-data (file: zip)
   */
  async import_dossier_documents(_context, { ocrdossierId, file }) {
    if (!ocrdossierId || !file) throw new Error("Dossier et fichier requis");
    const formData = new FormData();
    formData.append("file", file);
    const token = _context.rootState?.token ?? _context.state?.token;
    try {
      const response = await axios.post(
        domain + `/ocrdossiers/${ocrdossierId}/documents/import`,
        formData,
        {
          headers: {
            Authorization: `Bearer ` + token,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data?.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * Suppression d'un document complémentaire.
   * DELETE /api/ocrdossiers/documents/complementaires/{id}
   */
  async delete_document_complementaire(_context, id) {
    if (!id) throw new Error("ID document complémentaire requis");
    const token = _context.rootState?.token ?? _context.state?.token;
    try {
      await axios.delete(domain + `/ocrdossiers/documents/complementaires/${id}`, {
        headers: { Authorization: `Bearer ` + token },
      });
      return true;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * Dissocier des documents d'un dossier.
   * POST /api/ocrdossiers/{ocrdossier}/dissociate-documents
   * Body: { devis_ids: [], cee_ids: [], ah_ids: [] }
   */
  async dissociate_documents(_context, { ocrdossierId, devis_ids = [], cee_ids = [], ah_ids = [] }) {
    if (!ocrdossierId) throw new Error("ID dossier requis");
    const token = _context.rootState?.token ?? _context.state?.token;
    try {
      const response = await axios.post(
        domain + `/ocrdossiers/${ocrdossierId}/dissociate-documents`,
        { devis_ids, cee_ids, ah_ids },
        { headers: { Authorization: `Bearer ` + token } }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * Associer des documents à un dossier.
   * POST /api/ocrdossiers/{ocrdossier}/associate-documents
   * Body: { devis_ids: [], cee_ids: [], ah_ids: [] }
   */
  async associate_documents(_context, { ocrdossierId, devis_ids = [], cee_ids = [], ah_ids = [] }) {
    if (!ocrdossierId) throw new Error("ID dossier requis");
    const token = _context.rootState?.token ?? _context.state?.token;
    try {
      const response = await axios.post(
        domain + `/ocrdossiers/${ocrdossierId}/associate-documents`,
        { devis_ids, cee_ids, ah_ids },
        { headers: { Authorization: `Bearer ` + token } }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * Import de documents pour un document du dossier.
   * POST /api/ocrdossiers/documents/{documentId}/import-documents
   * Body: multipart/form-data avec pdf (un fichier) ou pdf[] (plusieurs fichiers) + category_id optionnel.
   */
  async import_document_documents(_context, { documentId, formData }) {
    if (!documentId) throw new Error("Document requis");
    if (!formData) throw new Error("FormData requis");
    
    const token = _context.rootState?.token ?? _context.state?.token;
    try {
      const response = await axios.post(
        domain + `/ocrdossiers/documents/${documentId}/import-documents`,
        formData,
        {
          headers: {
            Authorization: `Bearer ` + token,
          },
        }
      );
      return response.data?.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * Export des documents d'un dossier : envoie id + type de chaque document à l'API.
   * POST /api/ocrdossiers/{ocrdossierId}/documents/export
   * Body: { documents: [{ id: number, type: string }, ...] }  (type: devis | facture | ah | cee)
   */
  async export_dossier_documents(_context, { ocrdossierId, documents }) {
    if (!ocrdossierId || !documents || !documents.length) throw new Error("Dossier et documents requis");
    try {
      const response = await axios.post(
        domain + `/ocrdossiers/${ocrdossierId}/documents/export`,
        { documents },
        {
          headers: { Authorization: `Bearer ` + this.state.token },
          responseType: "blob",
        }
      );
      return { blob: response.data, headers: response.headers };
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * Export d'un ou plusieurs dossiers.
   * Un seul id  : GET /api/ocrdossiers/{id}/export
   * Plusieurs ids: GET /api/ocrdossiers/export?dossier_ids=107,108,109
   */
  /**
   * Import de dossiers depuis un fichier ZIP (template ou export).
   * POST /api/ocrdossiers/import-template avec multipart/form-data (file: zip)
   */
  async import_dossier(_context, file) {
    if (!file) throw new Error("Aucun fichier sélectionné");
    const formData = new FormData();
    formData.append("file", file);
    const token = _context.rootState?.token ?? _context.state?.token;
    try {
      const response = await axios.post(
        domain + "/ocrdossiers/import-template",
        formData,
        {
          headers: {
            Authorization: `Bearer ` + token,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data?.data ?? response.data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * Export du modèle/template pour l'import de dossiers.
   * GET /api/ocrdossiers/export-template
   */
  async export_dossier_template(_context) {
    try {
      const response = await axios.get(domain + "/ocrdossiers/export-template", {
        headers: { Authorization: `Bearer ` + (_context.rootState?.token ?? _context.state?.token) },
        responseType: "blob",
      });
      return { blob: response.data, headers: response.headers };
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async export_dossier(_context, ids) {
    const idList = Array.isArray(ids) ? ids.filter(Boolean) : ids != null ? [ids] : [];
    if (idList.length === 0) throw new Error("Aucun dossier à exporter");
    try {
      const isSingle = idList.length === 1;
      const url = isSingle
        ? domain + `/ocrdossiers/${idList[0]}/export`
        : domain + "/ocrdossiers/export";
      const config = {
        headers: { Authorization: `Bearer ` + this.state.token },
        responseType: "blob",
      };
      if (!isSingle) config.params = { dossier_ids: idList.join(",") };
      const response = await axios.get(url, config);
      return { blob: response.data, headers: response.headers };
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async lock_dossier({ commit }, id) {
    try {
      const response = await axios.put(
        domain + `/ocrdossiers/${id}/lock`,
        {},
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      const data = response.data?.data ?? response.data;
      if (data && data.id) commit("UPDATE_DOSSIER", { ...data, lock: 1 });
      else commit("UPDATE_DOSSIER", { id, lock: 1 });
      return data ?? true;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async unlock_dossier({ commit }, id) {
    try {
      const response = await axios.put(
        domain + `/ocrdossiers/${id}/unlock`,
        {},
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      const data = response.data?.data ?? response.data;
      if (data && data.id) commit("UPDATE_DOSSIER", { ...data, lock: 0 });
      else commit("UPDATE_DOSSIER", { id, lock: 0 });
      return data ?? true;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async lock_dossiers({ commit }, { ids }) {
    if (!ids || !ids.length) return;
    try {
      await axios.post(
        domain + "/ocrdossiers/lock",
        { ids },
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      ids.forEach((id) => commit("UPDATE_DOSSIER", { id, lock: 1 }));
      return true;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async unlock_dossiers({ commit }, { ids }) {
    if (!ids || !ids.length) return;
    try {
      await axios.post(
        domain + "/ocrdossiers/unlock",
        { ids },
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      ids.forEach((id) => commit("UPDATE_DOSSIER", { id, lock: 0 }));
      return true;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  async get_dossier_document(_context, { ocrdossierId, params = {} }) {
    try {
      const response = await axios.get(
        domain + `/ocrdossiers/${ocrdossierId}/document`,
        {
          params,
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      return response.data?.data ?? response.data;
    } catch (error) {
      const msg = error.response?.data?.message ?? error.message;
      const status = error.response?.status;
      const err = new Error(msg);
      err.status = status;
      err.is404 = status === 404;
      throw err;
    }
  },

  async lock_dossier_document(_context, ocrdossierId) {
    try {
      const response = await axios.put(
        domain + `/ocrdossiers/${ocrdossierId}/document/lock`,
        {},
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      return response.data?.data ?? response.data;
    } catch (error) {
      const msg = error.response?.data?.message ?? error.message;
      const status = error.response?.status;
      const err = new Error(msg);
      err.status = status;
      err.is404 = status === 404;
      throw err;
    }
  },

  async unlock_dossier_document(_context, ocrdossierId) {
    try {
      const response = await axios.put(
        domain + `/ocrdossiers/${ocrdossierId}/document/unlock`,
        {},
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      return response.data?.data ?? response.data;
    } catch (error) {
      const msg = error.response?.data?.message ?? error.message;
      const status = error.response?.status;
      const err = new Error(msg);
      err.status = status;
      err.is404 = status === 404;
      throw err;
    }
  },

  /**
   * GET /api/ocrdossiers/{ocrdossierId}/document - Liste des documents avec filtres
   */
  async fetchDocuments(_context, { ocrdossierId, params = {} }) {
    if (!ocrdossierId) throw new Error("OCR Dossier ID requis");
    
    try {
      const response = await axios.get(
        domain + `/ocrdossiers/${ocrdossierId}/document`,
        {
          params,
          headers: {
            Authorization: `Bearer ` + this.state.token,
          },
        }
      );
      
      const data = response.data?.data ?? response.data;
      return data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * Import de documents complémentaires dans un document
   * POST /api/ocrdossiers/{documentId}/complementaires/import avec multipart/form-data
   */
  async importComplementairesDocuments(_context, { documentId, formData }) {
    if (!documentId || !formData) throw new Error("Document ID et FormData requis");
    
    try {
      const response = await axios.post(
        domain + `/ocrdossiers/${documentId}/complementaires/import`,
        formData,
        {
          headers: {
            Authorization: `Bearer ` + this.state.token,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      
      const data = response.data?.data ?? response.data;
      return data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },
};

export default { state, mutations, getters, actions };
